'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _underscore = require('underscore');

var _underscore2 = _interopRequireDefault(_underscore);

var _ReactRecipe = require('./ReactRecipe');

var _ReactRecipe2 = _interopRequireDefault(_ReactRecipe);

var _BackboneRecipe = require('./BackboneRecipe');

var _BackboneRecipe2 = _interopRequireDefault(_BackboneRecipe);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ViewRecipe = function () {
    function ViewRecipe() {
        (0, _classCallCheck3.default)(this, ViewRecipe);

        this._states = [];
        this._viewClass = null;
        this._viewArguments = [];
        this._viewInstance = null;
        this._insideSelector = null;
        this._parentRecipe = null;
        this._viewType = null;
    }

    (0, _createClass3.default)(ViewRecipe, [{
        key: 'addState',

        // PUBLIC API
        value: function addState(navigationState) {
            var length = this._states.length;

            for (var i = 0; i < length; i++) {
                var existingState = this._states[i];

                if (existingState.getPath() === navigationState.getPath()) {
                    return;
                }
            }

            this._states.push(navigationState);

            return this;
        }
    }, {
        key: 'getStates',
        value: function getStates() {
            return this._states;
        }
    }, {
        key: 'toView',
        value: function toView(viewClass) {
            this._viewClass = viewClass;

            _underscore2.default.extend(this, _BackboneRecipe2.default);

            return this;
        }
    }, {
        key: 'toComponent',
        value: function toComponent(viewClass) {
            this._viewClass = viewClass;

            _underscore2.default.extend(this, _ReactRecipe2.default);

            return this;
        }
    }, {
        key: 'getViewClass',
        value: function getViewClass() {
            return this._viewClass;
        }
    }, {
        key: 'getViewInstance',
        value: function getViewInstance() {
            return this._viewInstance;
        }
    }, {
        key: 'getRootEl',
        value: function getRootEl() {
            console.warn('Method getRootEl should be implemented by viewRecipe');
        }
    }, {
        key: 'isMounted',
        value: function isMounted() {
            console.warn('Method isMounted should be implemented by viewRecipe');
        }
    }, {
        key: 'isInstantiated',
        value: function isInstantiated() {
            return this._viewInstance !== null;
        }
    }, {
        key: 'withArguments',
        value: function withArguments() {
            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
            }

            if (args.length > 5) {
                throw new Error('Uncle Bob says you want to use too many arguments');
            }
            this._viewArguments = args;

            return this;
        }
    }, {
        key: 'inside',
        value: function inside(selector) {
            this._insideSelector = selector;

            return this;
        }
    }, {
        key: 'getInsideSelector',
        value: function getInsideSelector() {
            return this._insideSelector;
        }
    }, {
        key: 'withParent',
        value: function withParent(parentRecipe) {
            this._parentRecipe = parentRecipe;
            return this;
        }
    }, {
        key: 'getParentRecipe',
        value: function getParentRecipe() {
            return this._parentRecipe;
        }
    }]);
    return ViewRecipe;
}(); //  weak


exports.default = ViewRecipe;
//# sourceMappingURL=ViewRecipe.js.map